import React, { useState } from "react";

import Form from "./Form";
import Loader from "../../general/Loader";
import { apiRequest } from "../../../hooks/apiRequest";
import { toast } from "../../../utils/helpers";

const Create = ({ toggleModal, getNumeracionesData, filtrosQuery }) => {
	const [saving, setSaving] = useState(false);
	const [errors, setErrors] = useState({});

	const createNumeracion = (event) => {
		event.preventDefault();
		setSaving(true);
		const data = new FormData(event.target);
		const values = Object.fromEntries(data.entries());

		if (values.tipo_documento === 'cheque' && !values.cuenta_id) {
			toast("Cuenta de Banco es requerido", 'error');
			setSaving(false);
			return;
		}


		apiRequest(data, "numeracion-documentos", "post").then((response) => {
			if (response.success) {
				getNumeracionesData(`numeracion-documentos?${filtrosQuery}`);
				toggleModal();
				setSaving(false);
			}
			if (response.code === 422) {
				setErrors({
					...response.data.message,
				});
				setSaving(false);
			}
		});
	};

	return (
		<form id="numeracionForm" method="post" onSubmit={createNumeracion}>
			<input type="hidden" name="_method" value="post" />
			<div className="popup__header">Crear Numeración</div>

			<Form numeracion={{}} errors={errors} />

			<div className="popup__footer">
				<button
					type="button"
					className="btn btn-plain"
					onClick={toggleModal}
				>
					Cancelar
				</button>
				{saving ? (
					<Loader type="small" />
				) : (
					<button type="submit" className="btn btn-primary">
						Crear
					</button>
				)}
			</div>
		</form>
	);
};

export default Create;
